let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("gr4Ep")), load("3h84f")]).then(() => parcelRequire('16LzX'));